import React from 'react';
import moment from 'moment-jalaali';
import JalaliDatePicker from './JalaliDatePicker';

/**
 * آداپتور JalaliDatePicker برای صفحاتی که تاریخ را به‌صورت رشتهٔ جلالی
 * «jYYYY/jMM/jDD» در state نگه می‌دارند (صفحات مالی).
 * تقویم شمسی کامل + دکمه امروز؛ مقدار خالی = بدون فیلتر.
 */
interface JalaliDateFieldProps {
  label: string;
  /** رشته جلالی jYYYY/jMM/jDD یا '' */
  value: string;
  onChange: (jalali: string) => void;
  width?: number | string;
  height?: number;
}

const JalaliDateField: React.FC<JalaliDateFieldProps> = ({
  label,
  value,
  onChange,
  width = 150,
  height = 38,
}) => {
  const iso = (() => {
    if (!value) return '';
    const m = moment(value.trim(), 'jYYYY/jMM/jDD');
    return m.isValid() ? m.format('YYYY-MM-DD') : '';
  })();

  return (
    <div style={{ width, flexShrink: 0 }}>
      <div style={{ fontSize: 11, color: 'var(--color-text-secondary)', marginBottom: 4 }}>
        {label}
      </div>
      <JalaliDatePicker
        value={iso}
        outputDateOnly
        height={height}
        placeholder="انتخاب تاریخ"
        onChange={(d) => onChange(d ? moment(d, 'YYYY-MM-DD').format('jYYYY/jMM/jDD') : '')}
      />
    </div>
  );
};

export default JalaliDateField;
